import React from 'react'

import { Speech3D } from '@cinch/oxd-components/icons/src'
import JargonSummary from '@cinch/oxd-components/jargon-summary/src'
import Title from '@cinch/oxd-components/page-title/src'
import SVG from '@cinch/oxd-components/svg/src'
import { Text } from '@cinch-labs/design-system'
import Layout from '@cinch/oxd-layouts/regular/src'

import Form from './components/search-form.component'
import Search from './utils/prismic-search'

import * as styles from './qna.module.css'

export interface PageProps {
  latestJargon: any[]
  query?: string
  i18n: Cinch.WebAppTranslations['jargon']
}

const Page: React.FC<PageProps> = ({ latestJargon = [], query = '', i18n }) => {
  const { title, recent, resultsTitle, noResultsTitle } = i18n
  const [results, setResults] = React.useState<any[]>([])
  const [isSearchPending, setSearchPending] = React.useState(false)
  const [searchQuery, setSearchQuery] = React.useState<string>(query)

  const searchJargon = (q: string) => {
    setSearchQuery(q || '')

    if (!q) {
      return
    }

    setSearchPending(true)

    return new Promise((resolve) => {
      Search(q, setResults)
        .then(() => {
          setSearchPending(false)
          resolve()
        })
        .catch(() => {
          setSearchPending(false)
          resolve()
        })
    })
  }

  React.useEffect(() => {
    if (searchQuery) {
      searchJargon(searchQuery)
    }
  }, [])

  return (
    <Layout>
      <Title>{title}</Title>
      <Form
        initialValues={{
          search: searchQuery,
        }}
        onSubmit={(values: any) => searchJargon(values.search)}
      />

      {!isSearchPending && results.length > 0 && (
        <>
          <Title element="h2">{resultsTitle}</Title>
          <div className={styles.related} data-testid="jargon-results-container">
            {results.map((summaryProps) => (
              <JargonSummary key={summaryProps.id} {...summaryProps} />
            ))}
          </div>
        </>
      )}

      {!isSearchPending && results.length === 0 && searchQuery && (
        <div className={styles.noResultsWrapper}>
          <Text oxford={true} className={styles.noResultsTitle} element="h2">
            {noResultsTitle}
          </Text>
          <SVG children={Speech3D} size={195} className={styles.noResultsImage} />
        </div>
      )}

      <Title element="h2">{recent}</Title>
      <div className={styles.related} data-testid="jargon-recent-container">
        {latestJargon.length > 0 &&
          latestJargon.map((summaryProps) => <JargonSummary key={summaryProps.id} {...summaryProps} />)}
      </div>
    </Layout>
  )
}

export default Page
